import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const AdaptMXSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["amx"],
    },
    params: {
      type: "object",
      properties: {
        tagId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
        adUnitId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
      },
      required: ["tagId"],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
